export default "__VITE_ASSET__BFW5FYoV__"